'use strict';

const $ = require('dibs-jquery-shim');
const isEmpty = require('lodash.isempty');
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const OverlaySpinner = require('dibs-overlay-spinner');
const SV = require('server-vars');
const Button = require('dibs-elements/dist/Button/Primary').default;
require('dibs-elements/dist/Button/buyer/Primary.css');

const transitionHelpers = require('../../../global/utils/transitionHelpers.es');
const ContextComponent = require('../../../global/components/ContextComponent');
const Modal = require('../../../global/components/Modal');
const ArrowRightIcon = require('dibs-vg/dist/react/arrow-right');
const ArrowLeftIcon = require('dibs-vg/dist/react/arrow-left');
const CloseIcon = require('dibs-vg/dist/react/close');
const PinchZoomComponent = require('../../../global/components/PinchZoomComponent');

const { noop } = require('../../../global/mixins/commonjs/basicUtils');

const { trackPinterestClick } = require('../../actions/pdpTrackingActions.es');
const PdpSocialIcons = require('../social/PdpSocialIcons');

const requestMoreImagesCopy = require('./RequestMoreImages/requestMoreImagesCopy.json');
const requestMoreImagesStyle = require('./RequestMoreImages/RequestMoreImages-style.scss');

class ZoomModal extends ContextComponent {
    constructor(props) {
        super(props);

        this.state = {
            index: props.startingIndex,
            numberVisible: props.numberVisible || 5,
            leftIndex: 0,
            binImageTransfrom: 'translate(0px)',
            previewImagePosition: 'calc(50%) 50%',
            inZoom: false,
        };

        this._closeModal = this._closeModal.bind(this);
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._onMouseMove = this._onMouseMove.bind(this);
        this._onLeftArrowClick = this._onLeftArrowClick.bind(this);
        this._onRightArrowClick = this._onRightArrowClick.bind(this);
        this._onThumbnailClick = this._onThumbnailClick.bind(this);
        this._onPinterestPin = this._onPinterestPin.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ index: nextProps.startingIndex });
    }

    componentDidUpdate(prevProps, prevState) {
        const { index, leftIndex, inZoom } = this.state;
        const { images } = this.props;
        const lastIndex = images.length - 1;
        const indexChanged = index !== prevState.index;
        const zoomChanged = inZoom !== prevState.inZoom;

        if (indexChanged) {
            if (prevState.index === lastIndex && index === 0) {
                // last to first
                this._calculateLeftIndexNext();
            } else if (index === lastIndex && prevState.index === 0) {
                // first to last
                this._calculateLeftIndexPrevious();
            } else if (prevState.index < index) {
                // next
                this._calculateLeftIndexNext();
            } else {
                // prev
                this._calculateLeftIndexPrevious();
            }
        }

        if (leftIndex !== prevState.leftIndex) {
            this._translatePosition();
        }

        if (zoomChanged || indexChanged) {
            transitionHelpers.transitionElement($(this.refs.previewImage));
        }
    }

    _calculateLeftIndexPrevious() {
        const { images } = this.props;
        const lastIndex = images.length - 1;
        const { index, numberVisible } = this.state;
        let { leftIndex } = this.state;

        if (index === lastIndex) {
            leftIndex = Math.max(0, lastIndex - (numberVisible - 1));
        } else if (leftIndex > 0) {
            leftIndex -= 1;
        }

        this.setState({ leftIndex });
    }

    _onLeftArrowClick() {
        const { images, onLeftArrowClick } = this.props;
        const lastIndex = images.length - 1;
        let { index } = this.state;
        index -= 1;

        if (index < 0) {
            index = lastIndex;
        }

        if (onLeftArrowClick) {
            onLeftArrowClick(index);
        }

        this._updateCurrent(index);
    }

    _calculateLeftIndexNext() {
        const { images } = this.props;
        const imagesLength = images.length;
        const { index, numberVisible } = this.state;
        let { leftIndex } = this.state;

        if (index === 0) {
            leftIndex = 0;
        } else if (leftIndex + numberVisible - 1 < imagesLength - 1) {
            leftIndex += 1;
        }

        this.setState({ leftIndex });
    }

    _onRightArrowClick() {
        const { images, onRightArrowClick } = this.props;
        let { index } = this.state;

        const imagesLength = images.length;
        index += 1;

        if (index >= imagesLength) {
            index = 0;
        }

        if (onRightArrowClick) {
            onRightArrowClick(index);
        }

        this._updateCurrent(index);
    }

    _onThumbnailClick(index) {
        this.props.onThumbnailClick(index);
        this._updateCurrent(index);
    }

    _updateCurrent(index) {
        this.props.onIndexChange(index);
        this.setState({ index });
    }

    _translatePosition() {
        const { leftIndex } = this.state;
        const offset = 100 * -leftIndex;

        this.setState({
            binImageTransfrom: `translate(${offset}%)`,
        });
    }

    _closeModal() {
        this.props.onRequestClose();
    }

    _onMouseEnter() {
        this.setState({ inZoom: true });
    }

    _onMouseLeave() {
        this.setState({ inZoom: false });
    }

    _onMouseMove(e) {
        const { owner } = this.props;
        const { inZoom } = this.state;
        const { previewImage } = this.refs;

        if (inZoom) {
            const mouseX = e.clientX;
            const mouseY = e.clientY;
            const bodyWidth = previewImage.clientWidth;
            const bodyHeight = previewImage.clientHeight;

            let translateX;
            let translateY;
            let previewImagePosition;

            // Calculate offset from the center for the X axis.
            switch (owner) {
                case 'checkout':
                    translateX = mouseX / bodyWidth * 100 - 20;
                    translateY = mouseY / bodyHeight * 100 - 20;
                    previewImagePosition = `calc(10% + ${translateX}%)${translateY}%`;
                    break;
                default:
                    translateX = (mouseX / bodyWidth - 0.5) * -50;
                    translateY = mouseY / bodyHeight * 100;
                    previewImagePosition = `calc(50% + ${translateX}%)${translateY}%`;
            }

            this.setState({ previewImagePosition });
        }
    }

    _getZoomImage() {
        const { index } = this.state;
        const { images } = this.props;

        return images[index] ? images[index].zoom.src : '';
    }

    _getPreviewImage() {
        const { inZoom, previewImagePosition } = this.state;
        const className = classnames('modal-carousel-image', {
            enlarged: inZoom,
        });
        let style;

        if (inZoom) {
            style = {
                backgroundPosition: previewImagePosition,
                backgroundImage: `url(${this._getZoomImage()})`,
            };
        }

        return (
            <div ref="previewImage" className={className} style={style}>
                <img
                    className="modal-carousel-small-image"
                    onMouseEnter={this._onMouseEnter}
                    src={this._getZoomImage()}
                />
                <OverlaySpinner
                    additionalWrapperClasses="modal-carousel-lazy-spinner"
                    position="isAbsolute"
                />
            </div>
        );
    }

    _getThumbnails() {
        const { index, binImageTransfrom } = this.state;

        return this.props.images.map((image, i) => {
            const className = classnames('carousel-bin-image-wrapper', {
                selected: index === i,
            });

            return (
                <div
                    key={i}
                    onClick={() => this._onThumbnailClick(i)}
                    className={className}
                    style={{ transform: binImageTransfrom }}
                >
                    <div
                        className="carousel-bin-image"
                        style={{ backgroundImage: `url(${image.small.src})` }}
                    />
                </div>
            );
        });
    }

    _getArrows() {
        const { images } = this.props;

        if (images.length > 1) {
            return {
                leftArrow: (
                    <span className="modal-carousel-previous" onClick={this._onLeftArrowClick}>
                        <ArrowLeftIcon className="modal-carousel-previous-icon" />
                    </span>
                ),
                rightArrow: (
                    <span className="modal-carousel-next" onClick={this._onRightArrowClick}>
                        <ArrowRightIcon className="modal-carousel-next-icon" />
                    </span>
                ),
            };
        } else {
            return {
                leftArrow: null,
                rightArrow: null,
            };
        }
    }

    _getSocialData() {
        const { socialData } = this.props;
        const image = this._getZoomImage();

        return Object.assign({}, socialData, { image });
    }

    _onPinterestPin() {
        const suffix = 'zoom modal';
        this.context.executeAction(trackPinterestClick, { suffix });
    }

    renderSocialData() {
        const { itemId, selectedItems, relay, itemData } = this.props;
        return (
            <div
                className={`modal-carousel-actions ${requestMoreImagesStyle.socialIconsContainer}`}
            >
                <PdpSocialIcons
                    id={itemId}
                    socialData={this._getSocialData()}
                    onPinterestPin={this._onPinterestPin}
                    pinterestTracking={{ suffix: 'modal' }}
                    printIcon={false}
                    iconType="colored"
                    selectedItems={selectedItems}
                    relay={relay}
                    itemData={itemData}
                />
            </div>
        );
    }

    render() {
        const {
            wrapperClasses,
            title,
            socialData,
            heartComponent,
            onContactDealerClick,
        } = this.props;
        const { leftArrow, rightArrow } = this._getArrows();
        const hasSocialData = !isEmpty(socialData);
        const isDesktop = SV.get('settings.isDesktop');

        return (
            <Modal className={wrapperClasses} onRequestClose={this._closeModal} {...this.props}>
                <span onClick={this._closeModal} className="modal-close" title="Close">
                    <CloseIcon className="modal-close-btn" />
                </span>

                <div className="modal-carousel2">
                    <div
                        ref="modalBody"
                        onMouseLeave={this._onMouseLeave}
                        onMouseMove={this._onMouseMove}
                        className="modal-carousel-body"
                    >
                        {leftArrow}
                        {!isDesktop && (
                            <PinchZoomComponent className="mobile-zoom-carousel-image-wrapper">
                                <div
                                    className="mobile-zoom-carousel-image"
                                    style={{ backgroundImage: `url(${this._getZoomImage()})` }}
                                />
                            </PinchZoomComponent>
                        )}
                        {isDesktop && this._getPreviewImage()}
                        {rightArrow}
                    </div>
                    <div className="modal-carousel-footer">
                        <div className="modal-carousel-social social-share-nav">
                            {heartComponent ? heartComponent : null}
                            <span className="modal-carousel-title">{title}</span>
                        </div>
                        <div className="modal-carousel-bin">
                            <div ref="thumbnails" className="carousel-bin">
                                {this._getThumbnails()}
                            </div>
                        </div>
                        <div className={requestMoreImagesStyle.buttonContainer}>
                            <Button
                                size="small"
                                onClick={() => {
                                    onContactDealerClick({
                                        isRequestMoreImages: true,
                                        linkLocation: 'pdp image carousel zoom',
                                    });
                                }}
                            >
                                {requestMoreImagesCopy.requestImages}
                            </Button>
                        </div>
                        {hasSocialData ? this.renderSocialData() : null}
                    </div>
                </div>
            </Modal>
        );
    }
}

ZoomModal.propTypes = {
    owner: PropTypes.string,
    isOpen: PropTypes.bool,
    heartComponent: PropTypes.object,
    onRequestClose: PropTypes.func,
    images: PropTypes.array,
    startingIndex: PropTypes.number,
    onIndexChange: PropTypes.func,
    wrapperClasses: PropTypes.string,
    socialData: PropTypes.object,
    onLeftArrowClick: PropTypes.func,
    onRightArrowClick: PropTypes.func,

    itemId: PropTypes.string.isRequired,
    onThumbnailClick: PropTypes.func.isRequired,
    onContactDealerClick: PropTypes.func,
    selectedItems: PropTypes.array,
    relay: PropTypes.object,
    itemData: PropTypes.object,
};

ZoomModal.defaultProps = {
    onRequestClose: noop,
    wrapperClasses: 'modal-carousel-wrapper',
    images: [],
    startingIndex: 0,
    onIndexChange: noop,
    onLeftArrowClick: noop,
    onRightArrowClick: noop,
    onContactDealerClick: () => {},
};

module.exports = ZoomModal;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Carousel/ZoomModal.jsx